<template>
	<dynvibebasechart
		:id="axiosComputed"
		ref="basechart"
		@created="chartCreated"
		:functionClick="clickGraph"
		:type="type"
	></dynvibebasechart>
</template>
<script>
import dynvibebasechart from "@/components/vueCharts/DynvibeBaseChart.vue";
import graphMixin from "@/mixins/graphMixin.js";

export default {
	name: "dynvibestock",
	mixins: [graphMixin],
	components: {
		dynvibebasechart: dynvibebasechart,
	},
	props: {
		stock: {
			type: Boolean,
			default: false,
		},
		value: {
			type: String,
			default: "",
		},
		typo: {
			type: String,
			default: "",
		},
		entity: {
			type: String,
			default: "Posts",
		},
		level: {
			type: String,
			default: "",
		},
		displaycumulative: {
			type: Boolean,
			default: true,
		},
		trendfilters: Object,
		semanticfilters: Object,
		filters: Object,
		selectedCountry: {
			type: String,
			default: "",
		},
		graphrange: {
			type: String,
			default: "day",
		},
	},
	methods: {
		chartCreated() {
			this.baseChart = this.$refs.basechart;
			this.setChartOptions();

			if (this.axiosComputed === "categoriesVolume") {
				this.getCountriesList();
			}
		},
		setChartOptions() {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();
			chartOptions = {
				title: {
					text: this.value,
				},
				plotOptions: {
					series: {
						tooltip: {
							valueDecimals: 0,
						},
						animation: {
							duration: 3000,
						},
						point: {
							events: {
								click: this.clicked,
							},
						},
					},
				},
				legend: {
					enabled: true,
				},
				exporting: {
					enabled: false,
				},
			};

			chartOptions.rangeSelector = {
				selected: 6,
				buttonTheme: {
					width: 80,
				},
				buttons: [
					{
						type: "month",
						count: 1,
						text: "1m",
						events: {
							click: () => {
								this.$emit("zoomchart", 0);
							},
						},
					},
					{
						type: "month",
						count: 3,
						text: "3m",
						events: {
							click: () => {
								this.$emit("zoomchart", 1);
							},
						},
					},
					{
						type: "month",
						count: 6,
						text: "6m",
						events: {
							click: () => {
								this.$emit("zoomchart", 2);
							},
						},
					},
					{
						type: "ytd",
						text: "YTD",
						events: {
							click: () => {
								this.$emit("zoomchart", 3);
							},
						},
					},
					{
						type: "year",
						count: 1,
						text: "1y",
						events: {
							click: () => {
								this.$emit("zoomchart", 4);
							},
						},
					},
					{
						type: "all",
						text: "All",
						events: {
							click: () => {
								this.$emit("zoomchart", 5);
							},
						},
					},
					{
						type: "day",
						text: "Date Picker",
						count: this.countDatePickerDays(),
						events: {
							click: () => {
								this.$emit("zoomchart", 6);
							},
						},
					},
				],
			};

			baseChart.updateChartOptions(chartOptions);
		},
		countDatePickerDays() {
			let prev, act;
			// Modale
			if (typeof this.filters == "undefined") {
				prev = this.$moment(this.datemixin.gte);
				act = this.$moment(this.datemixin.lte);
			} else {
				prev = this.$moment(this.filters.date.gte);
				act = this.$moment(this.filters.date.lte);
			}

			return act.diff(prev, "days");
		},
		getCumulative(data) {
			let cumulativeData = [];
			let sum = 0;

			for (let i = 0; i < data.length; i++) {
				for (let j = 0; j < data[i]["data"].length; j++) {
					sum += data[i]["data"][j][1];
					cumulativeData.push([data[i]["data"][j][0], sum]);
				}
			}
			return cumulativeData;
		},
		loadChartData(results) {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();
			let seriesOptions = [];

			for (let i = 0; i < results.length; i++) {
				seriesOptions[i] = {
					color: this.graphColor[i],
					name: results[i]["name"],
					data: results[i]["data"],
					dataGrouping: {
						enabled: true,
						forced: true,
						approximation: "sum",
						units: [[this.graphrange, [1]]],
					},
					tooltip: {
						valueDecimals: 0,
					},
				};
			}

			if (this.displaycumulative) {
				seriesOptions.push({
					color: "#000",
					name: "Cumulative",
					data: this.getCumulative(results),
					dataGrouping: {
						enabled: true,
						forced: true,
						approximation: "high",
						units: [[this.graphrange, [1]]],
					},
					tooltip: {
						valueDecimals: 0,
					},
				});
			}

			let noData = results.length === 0;
			this.baseChart.setNoData(noData);
			this.$emit("noStockData", noData);
			chartOptions.series = seriesOptions;
			chartOptions.rangeSelector.buttons[6].count = this.countDatePickerDays();
			baseChart.updateChartOptions(chartOptions);
		},
		changeZoom(zoom) {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();
			chartOptions.rangeSelector.selected = zoom;
			baseChart.updateChartOptions(chartOptions);
		},
		clicked(item) {
			let datePrev = this.$moment(item.point.x).format("YYYY-MM-DD");
			let range = this.graphrange === "week" ? "isoWeek" : this.graphrange;
			let dateAct = this.$moment(item.point.x).endOf(range).format("YYYY-MM-DD");

			this.$emit("clicked", {
				keyword: item.point.series.name,
				country: this.selectedCountry,
				date: {
					gte: datePrev,
					lte: dateAct,
				},
			});
		},
		getCountriesList() {
			let p = {};
			p.parameters = { ...this.filters };

			this.$axios
				.get(this.$backendUrl + "countriesList", {
					params: p,
					paramsSerializer: (params) => {
						return this.$Qs.stringify(params, { arrayFormat: "brackets" });
					},
				})
				.then((response) => {
					this.$emit("getcountries", response.data);
				});
		},
	},
	watch: {
		selectedCountry: function () {
			let p = { ...this.filters };
			p.country = [this.selectedCountry];
			this.loadComponent(p);
		},
		filters: {
			deep: true,
			handler() {
				if (this.axiosComputed == "categoriesVolume") {
					this.getCountriesList();
				}
			},
		},
	},
};
</script>
